import React from 'react'
import LandscapingHero from './LandscapingHero'
import LandscapingContent from './LandscapingContent'
import LandscapingServices from './LandscapingServices'
import LandscapingTransform from './LandscapingTransform'
import Landscapingsection from './Landscapingsection'
import Footer from '../../Footer/Footer'










function LandscapingCorporate() {
    return (
        <div>
            <LandscapingHero/>
            <LandscapingContent/>
            <LandscapingServices/>
            <Landscapingsection/>
            <LandscapingTransform/>
            <Footer/>
            
        </div>
    )
}

export default LandscapingCorporate
